import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import type { RouteLocationNormalized } from "vue-router"


export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (to.path !== "/" && to.path.endsWith("/")) {
		to.path = to.path.replace(/\/+$/, "");
		return navigateTo(to.path, {redirectCode: 301});
	}
})
